import { Routes } from '@angular/router';
import { SessionTokenGuard } from './shared/router/guard/session';
import { ForbiddenComponent } from './error/forbidden/forbidden.component';
import { SingleSignOnComponent } from './session/component/single-sign-on/single-sign-on.component';

export const AppRoutes: Routes = [
  {
    pathMatch: 'full',
    path: '',
    loadChildren: './static/static.module#StaticModule'
  },
  {
    pathMatch: 'full',
    path: '',
    loadChildren: './account/account.module#AccountModule'
  },
  {
    pathMatch: 'full',
    path: '',
    loadChildren: './dashboard/dashboard.module#DashboardModule',
    canActivate: [ SessionTokenGuard ]
  },
  {
    path: 'login',
    loadChildren: './session/session.module#SessionModule'
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent
  },
  {
    path: 'sso',
    component: SingleSignOnComponent
  },
  {
    path: '**',
    redirectTo: '/campaign'
  }
];
